import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import VueCookies from 'vue-cookies'
import 'element-ui/lib/theme-chalk/index.css';
import api from './utils/request/api';
import router from './router/index';
import utils from './utils/index'

Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.use(ElementUI);
Vue.use(utils);
new Vue({
    router: router,
    render: h => h(App),
}).$mount('#app');
